export function HomePage() {
  return (
    <div>
      <h1>Welcome to GTB</h1>
      <p>Building Management System</p>
    </div>
  );
}
